import { ICON_TYPES } from '../constants';

export const RunningCyclingTrack = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_13193_23883)">
        <path
          d="M19.25 9.625V11.375H15.2556L13.2633 8.06575L11.5553 12.2098L10.0538 11.2604L11.8125 7H10.1675L8.358 11.403C8.27981 11.5933 8.27115 11.805 8.33356 12.001C8.39596 12.1971 8.52544 12.3648 8.69925 12.4749L13.1163 15.2679V21H11.3663V16.2321L7.76475 13.9571C7.24211 13.6274 6.85254 13.1239 6.66464 12.5352C6.47673 11.9465 6.50253 11.3104 6.7375 10.7389L8.27225 7H5.79075L4.28312 10.0161L2.71688 9.23388L4.70925 5.25H12.1275C12.5799 5.25133 13.0243 5.36896 13.4181 5.59161C13.8119 5.81426 14.1419 6.13443 14.3763 6.52138L16.2444 9.625H19.25ZM13.125 4.375C13.5576 4.375 13.9806 4.24671 14.3403 4.00634C14.7 3.76597 14.9804 3.42433 15.146 3.02462C15.3116 2.62491 15.3549 2.18507 15.2705 1.76074C15.1861 1.33641 14.9777 0.946632 14.6718 0.640705C14.3659 0.334778 13.9761 0.126438 13.5518 0.0420332C13.1274 -0.042372 12.6876 0.000947809 12.2879 0.166515C11.8882 0.332081 11.5465 0.612459 11.3062 0.972191C11.0658 1.33192 10.9375 1.75485 10.9375 2.1875C10.9375 2.76766 11.168 3.32406 11.5782 3.7343C11.9884 4.14453 12.5448 4.375 13.125 4.375ZM5.97187 14.7L5.53962 15.75H0.875V17.5H6.71038L7.41037 15.8008L6.8285 15.4333C6.51245 15.2269 6.2245 14.9804 5.97187 14.7Z"
          fill="#43494F"
        />
      </g>
      <defs>
        <clipPath id="clip0_13193_23883">
          <rect width="21" height="21" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

RunningCyclingTrack.iconType = ICON_TYPES.RUN_CYCLE_TRACK;
